/* eslint-disable @typescript-eslint/no-explicit-any */
import { Directive, HostBinding, Input, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[nimbusBulkValue]',
  exportAs: 'nimbusBulkValue',
  standalone: false,
})
export class NimbusBulkValueDirective implements OnChanges {
  @HostBinding('class.bulk-edit-equal')
  public isEqual: boolean;

  @HostBinding('class.bulk-edit-not-equal')
  public isNotEqual: boolean;

  @HostBinding('class.bulk-edit-disabled')
  public isDisabled: boolean;

  @Input()
  public isBulk: boolean;

  @Input()
  public identical: boolean;

  @Input()
  public nimbusBulkValue: any;

  @Input()
  public bulkDisabled: boolean;

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes?.isBulk || changes?.identical || changes?.nimbusBulkValue || changes?.bulkDisabled) {
      this.isDisabled = this.isBulk && this.bulkDisabled;
      // do not apply equal/not equal styles for the disabled elements
      if (this.identical === null || this.nimbusBulkValue === null || this.bulkDisabled) {
        return;
      }
      const identical = this.identical && !!this.nimbusBulkValue?.identical;
      this.bindState(identical);
    }
  }

  protected bindState(identical: boolean): void {
    this.isEqual = this.isBulk && identical;
    this.isNotEqual = this.isBulk && !this.isEqual;
  }
}
